import { Table, TableProps } from '@mantine/core';

import classNames from './Table.module.scss';

/**
 * @deprecated Use `TableProps` from `@zorro/design-system/v2/Table` instead
 */
export type ITableProps = TableProps & { variant?: 'legacy' | 'sticky' };

/**
 * @deprecated Use `Table` from `@zorro/design-system/v2/Table` instead
 */
export function ZorroTable({
  withTableBorder = true,
  horizontalSpacing = 'md',
  verticalSpacing = 'sm',
  withColumnBorders = true,
  variant = 'legacy',
  ...props
}: ITableProps) {
  return (
    <Table
      classNames={classNames}
      withTableBorder={withTableBorder}
      horizontalSpacing={horizontalSpacing}
      verticalSpacing={verticalSpacing}
      withColumnBorders={withColumnBorders}
      data-variant={variant}
      {...props}
    />
  );
}

ZorroTable.Thead = Table.Thead;
ZorroTable.Tbody = Table.Tbody;
ZorroTable.Tr = Table.Tr;
ZorroTable.Th = Table.Th;
ZorroTable.Td = Table.Td;
